/* eslint-disable import/prefer-default-export */
export const siteConfig = {
  maxContentWidth: '1280px',
};
